import dompurify from 'dompurify';

interface SanitizedHtml {
  __html: string;
}

const sanitize = (markup: string): SanitizedHtml => {
  return { __html: dompurify.sanitize(markup) };
};

export default sanitize;
